<template>
  <v-container>
    <v-card :loading="loading">
      <v-card-title>
        Reflection Logging History
      </v-card-title>
      <v-card-actions>
        <v-btn @click="changeWeekIndex(-1)">Previous Week</v-btn>
        <v-spacer></v-spacer>
        <v-btn :disabled="index == 0" @click="changeWeekIndex(1)">Next Week</v-btn>
      </v-card-actions>
      <v-card-text>
        <v-simple-table v-if="!loading">
          <thead>
            <tr>
              <th class="text-left">Date</th>
              <th class="text-left">Sleep</th>
              <!-- <th class="text-left">Nutrition</th> -->
              <th class="text-left">Hydration</th>
              <th class="text-left">Mood</th>
              <th class="text-left">Feeling</th>
              <!-- <th v-for="habit in habits" :key="habit.node.id" class="text-left">
                {{ getHabitTitle(habit.node) }}
              </th> -->
            </tr>
          </thead>
          <tbody>
            <tr v-for="day in getDays()" :key="day">
              <td>{{ formatDate(day) }}</td>
              <td>{{ getSleep(day) }}</td>
              <!-- no longer in use? we now have the overall day rating on the nutrition log modal -->
              <!-- <td>
                <span :class="getDayClass(getRatingLog(day, nutritionLog))">
                  {{ getRatingLog(day, nutritionLog) }}
                </span>
              </td> -->
              <td>
                <span>
                  {{ getHydrationMilliliters(day, hydrationLog) }}
                  <span v-if="getHydrationMilliliters(day, hydrationLog) != '-'">ml</span>
                </span>
              </td>
              <td>
                <v-icon v-if="getMoodIcon(day)" :color="getMoodColor(day)">
                  {{ getMoodIcon(day) }}
                </v-icon>
              </td>
              <td>
                <span v-if="getFeeling(day)" class="font-weight-bold" :style="{ color: getFeeling(day).hexCode }">
                  {{ getFeeling(day).title }}
                </span>
              </td>
              <!-- <td v-for="habit in habits" :key="habit.node.id" class="text-left">
                <span v-if="getHabitStatus(day, habit.node) === true"
                  ><v-icon color="green">mdi-check-circle</v-icon></span
                >
                <span v-if="getHabitStatus(day, habit.node) === false"
                  ><v-icon color="red">mdi-close-circle</v-icon></span
                >
                <span v-if="getHabitStatus(day, habit.node) === ''">-</span>
              </td> -->
            </tr>
          </tbody>
        </v-simple-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { REFLECTIONS_QUERY } from "@/constants/graphql/reflection/reflection";
import { YYYYMMDD_readable } from "@/lib/fancy_date";
import FeelingMixin from "@/components/shared/mixins/FeelingMixin";
export default {
  name: "Reflection",
  props: ["userId"],
  mixins: [FeelingMixin],
  data() {
    return {
      loading: true,
      index: 0,
      userMood: [],
      hydrationLog: [],
      userFeelings: [],
      sleepLog: [],
      habits: [],
    };
  },
  methods: {
    formatDate(date) {
      return YYYYMMDD_readable(date);
    },
    changeWeekIndex(count) {
      this.index += count;
    },
    getSleep(date) {
      let data = this.sleepLog.filter((log) => log.node.date == date);
      if (data.length == 0) {
        return "-";
      } else {
        let ratingString = "";
        if (data[0].node.rating > 0) {
          switch (data[0].node.rating) {
            case 1:
              ratingString = " / 1 - Poor";
              break;
            case 2:
              ratingString = " / 2 - OK";
              break;
            case 3:
              ratingString = " / 3 - Good";
              break;
            case 4:
              ratingString = " / 4 - Great";
              break;
          }
        }
        return `${this.$options.filters.humanizeSeconds(data[0].node.seconds)} ${ratingString}`;
      }
    },
    getRatingLog(date, log) {
      let data = log.filter((log) => log.node.date == date);
      if (data.length == 0) {
        return "-";
      } else {
        return data[0].node.rating;
      }
    },
    getHydrationMilliliters(date, log) {
      let data = log.filter((log) => log.node.date == date);
      if (data.length == 0) {
        return "-";
      } else {
        return data[0].node.milliliters;
      }
    },
    getMoodIcon(day) {
      const moodLog = this.getLog(day, this.userMood);
      if (moodLog?.mood == null) {
        return;
      }
      return this.getEmoticonForRating(moodLog.mood);
    },
    getMoodColor(day) {
      const moodLog = this.getLog(day, this.userMood);
      if (moodLog?.mood == null) {
        return;
      }
      return this.getColorForRating(moodLog.mood);
    },
    getFeeling(day) {
      const feelingLog = this.getLog(day, this.userFeelings);
      if (feelingLog?.feeling == null) {
        return;
      }
      return feelingLog.feeling;
    },
    getLog(date, log) {
      let data = log.filter((log) => log.node.date == date);
      if (data.length == 0) {
        return "-";
      } else {
        return data[0].node;
      }
    },
    getDayClass(val) {
      if (val == "-") {
        return "not-submitted";
      }
      if (val <= 50) {
        return "non-compliant";
      }
      if (val == 75) {
        return "compliant";
      }

      return "largely-compliant";
    },
    getDays() {
      let endDate = this.$moment().add(this.index * 7, "days");
      let tempDate = "";
      let days = [];
      days.push(endDate.format("YYYY-MM-DD"));
      for (var i = 0; i < 6; i += 1) {
        tempDate = endDate.subtract(1, "days");
        days.push(tempDate.format("YYYY-MM-DD"));
      }
      return days;
    },
    getHabitTitle(habit) {
      return habit.title ? habit.title : habit?.habitOption.title;
    },
    getHabitStatus(day, habit) {
      const data = habit.habitentrySet?.edges?.find((habit) => habit.node.date == day);
      if (!data?.node) {
        return "";
      }
      return !!data?.node?.status;
    },
  },
  apollo: {
    sleepLog: {
      query: REFLECTIONS_QUERY,
      variables() {
        let encoded_json_payload = btoa("UserNode:" + this.userId);
        let endDate = this.$moment().add(this.index * 7, "days");
        let startDate = this.$moment().add((this.index - 1) * 7, "days");
        return {
          userId: encoded_json_payload,
          date_Lte: endDate.format("YYYY-MM-DD"),
          date_Gte: startDate.format("YYYY-MM-DD"),
        };
      },
      fetchPolicy: "cache-and-network",
      result(response) {
        if (response.data) {
          this.loading = false;
          this.userMood = response.data.userMood.edges;
          this.hydrationLog = response.data.hydrationLog.edges;
          this.userFeelings = response.data.userFeelings.edges;
          this.sleepLog = response.data.sleepLog.edges;
          //this.habits = response.data.habitsQuery.edges;
        }
      },
    },
  },
};
</script>

<style scoped>
.not-submitted {
  border: 3px solid red;
  text-align: center;
  padding: 5px;
  border-radius: 12px;
}
.non-compliant {
  border: 3px solid #fc4b8b;
  text-align: center;
  padding: 5px;
  border-radius: 12px;
}
.compliant {
  border: 3px solid #ffc50b;
  text-align: center;
  padding: 5px;
  border-radius: 12px;
}
.largely-compliant {
  border: 3px solid #15b775;
  text-align: center;
  padding: 5px;
  border-radius: 12px;
}
</style>
